import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-6 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="font-serif text-4xl font-light text-ink">Checkout cancelled</h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-ink/60">
        No charge was made. Whenever you're ready, the shop will be right where you left it.
      </p>
      <Link
        to="/shop"
        data-testid="cancel-back-to-shop"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-sage px-8 py-4 text-sm font-medium text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-sage-deep"
      >
        <ArrowLeft size={15} /> Continue browsing
      </Link>
    </div>
  );
}
